const groupPrefix = createApiRoute(ApiModule.PURCHASE, ApiAuthorization.EMPLOYEE, ApiDataModel.ORDERS)
const suppliersPrefix = createApiRoute(ApiModule.SUPPLIER, ApiAuthorization.EMPLOYEE)

export const apiProductsExport = {
	exportProductsBySupplier: async (
		supplierID: number,
		supplierName: string,
		purchaseOrderId: number,
		supplierOrderSequence?: number,
	) => {
		await apiCommon(`${groupPrefix}/${purchaseOrderId}/supplier/${supplierID}/export`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, {
				supplier_order_sequence: supplierOrderSequence,
			}),
			isFileDownload: true,
			downloadFilename: `${supplierName} (zlecenie zakupowe numer ${purchaseOrderId}).xlsx`,
		})
	},

	importOffer: async (file: File, supplierID: number, purchaseOrderId: number, supplierOrderSequence?: number) => {
		const formData = new FormData()
		formData.append('file', file)
		const normalizedSupplierOrderSequence = supplierOrderSequence ?? 1

		const { data, meta } = await apiCommon<string>(
			`${suppliersPrefix}/purchase_orders/${purchaseOrderId}/suppliers/${supplierID}/import`,
			{
				method: 'POST',
				...createQuery(undefined, undefined, undefined, {
					supplier_order_sequence: normalizedSupplierOrderSequence,
				}),
				body: formData,
			},
			'pl',
			true,
		)

		return { data, meta }
	},
}
